/*
 * @Author: Chao Yang
 * @Date: 2020-07-22 03:25:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 14:06:23
 */

import { BaseProxy } from '../../base.proxy';
import { IData } from 'src/app/domain/model/dashboard';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class AggregateDataProxy extends BaseProxy {
  constructor(_http: HttpClient, private datePipe: DatePipe) {
    super(_http);
  }

  GetAggregate(
    start: Date,
    end: Date,
    dataModel: number,
    accounts: IDtoAccountGroup.IAccountItem[]
    , viewDataForAllInvestors: boolean
  ) {
    let startStr = start
      ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
      : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '',
      endStr = end
        ? this.datePipe.transform(end, 'yyyy-MM-dd') + ''
        : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '';
    return this._http.post<IData>(
      `/ip/api/dashboard/aggregate?start=${startStr}&end=${endStr}&mode=${dataModel}&viewDataForAllInvestors=${viewDataForAllInvestors}`,
      accounts
    );
  }

  GenerateExportUrl(
    start: Date,
    end: Date,
    dataModel: number,
    accounts: IDtoAccountGroup.IAccountItem[]
    , viewDataForAllInvestors: boolean
  ) {
    let startStr = start
      ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
      : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '',
      endStr = end
        ? this.datePipe.transform(end, 'yyyy-MM-dd') + ''
        : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '';
    return this._http.post<string>(
      `/ip/api/dashboard/aggregate/export?start=${startStr}&end=${endStr}&mode=${dataModel}&viewDataForAllInvestors=${viewDataForAllInvestors}`,
      accounts
    );
  }

  ExportUrl(resourceId: string) {
    return `/ip/api/dashboard/aggregate/export?resourceId=${resourceId}`;
  }
}
